import React from 'react'
import { Switch, Route } from "react-router-dom"
import PaymentMenu from './payment-menu.component'
import Wallet from './wallet/wallet.component'
import Transactions from './transactions/transactions.component'
import Obligations from './obligations/obligations.component'

const PaymentController = () => {
    return (
        <div className="payment">
            <Switch>
                <Route path="/payment/transactions" component={Transactions} />
                <Route path="/payment/obligations" component={Obligations} />
                <Route path="/payment/wallet" component={Wallet} />
                <Route exact path="/payment" component={PaymentMenu} />
            </Switch>
        </div>
    )
}

export default PaymentController